import React from 'react';
import { motion } from 'framer-motion';
import styles from './HtmlRenderer.module.css';

const HtmlRenderer = ({ contentDetails, viewerUrl }) => {
  return (
    <motion.div
      className={styles.container}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
    >
      <iframe
        src={viewerUrl}
        title={contentDetails?.title || 'HTML Content'}
        className={styles.iframe}
        // Strict sandboxing for HTML to protect parent application
        // Omitting 'allow-same-origin' forces a unique origin, protecting parent cookies/storage
        // Omitting 'allow-top-navigation' prevents it from redirecting the parent
        sandbox="allow-scripts allow-forms allow-popups"
      ></iframe>
    </motion.div>
  );
};

export default HtmlRenderer;